module.exports = __webpack_public_path__ + "static/media/portfolio1 (1).ddadc49e.jpeg";